import { IsNotEmpty, IsNumber, IsString } from 'class-validator';

export class UserAssetDto {
    @IsString()
    @IsNotEmpty()
    name!: string;

    @IsString()
    @IsNotEmpty()
    metadata!: string;

    @IsString()
    @IsNotEmpty()
    description!: string;

    @IsNumber()
    @IsNotEmpty()
    part!: number;

    @IsString()
    @IsNotEmpty()
    userId!: string;

    @IsString()
    @IsNotEmpty()
    id!: string;

    @IsString()
    @IsNotEmpty()
    createdAt!: Date;

    @IsString()
    @IsNotEmpty()
    updatedAt!: Date;
}
